import { OrderAddress } from "cdes-api/dto/OrderAddress";
import { Country } from "cdes-api/dto/Country";

export class OrderAddressEditInfo {
    orderAddress : OrderAddress;
    countries : Country[] = [];
}
